import React, { useEffect, useMemo, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getReports, getReport, createReport, deleteReport, clearCurrentReport, saveReport } from "../store/actions/reportActions";
import Report from "../components/Report/ReportOverlay";
import ControlReport from "../components/Report/ControlReport";
import Popup from 'reactjs-popup';
import { generateReportJSON } from "../utils/reportUtils";
import { LuPlus, LuDownload } from "react-icons/lu";
import { BsThreeDots } from "react-icons/bs";

function ReportsPage(props) {
  const {
    token,
    activeDepartmentId,
    reportsList,
    controlReportsList,
    activeReportId,
    newlyCreatedReportId,
    getReportsFN,
    getReportFN,
    createReportFN,
    deleteReportFN,
    clearCurrentReportFN,
    currentReport,
    saveReportFN,
    controlReports,
  } = props

  const history = useHistory()


  const [page, setPage] = useState("risk");
  const [selectedReportID, setselectedReportID] = useState(null);
  const [selectedControlReportID, setselectedControlReportID] = useState(null);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isControlReportOpen, setIsControlReportOpen] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  // Fetch reports on mount
  useEffect(() => {
    console.log("Tryin to get Reports", token)
    if (token) {
      getReportsFN()
    }
  }, [token, getReportsFN])

  const [viewMode, setViewMode] = useState("grid"); // or "table"
  const [searchQuery, setSearchQuery] = useState("");

  // 3-dots menu state (if you don't already have it here)

  // filtered lists (case-insensitive title match)
  const filteredReportsList = useMemo(() => {
    if (!reportsList) return [];
    const q = searchQuery.trim().toLowerCase();
    if (!q) return reportsList;
    return reportsList.filter(r => (r.title || "").toLowerCase().includes(q));
  }, [reportsList, searchQuery]);

  const filteredControlReportsList = useMemo(() => {
    if (!controlReportsList) return [];
    const q = searchQuery.trim().toLowerCase();
    if (!q) return controlReportsList;
    return controlReportsList.filter(r => (r.title || "").toLowerCase().includes(q));
  }, [controlReportsList, searchQuery]);

  // if you use toggleDropdown in JSX



  const riskCount = (filteredReportsList ?? []).length;
  const controlCount = (filteredControlReportsList ?? []).length;




  // If a report was just created, set it active and reset


  // Group reports by year
  //   const reportsByYear = useMemo(() => {
  //     return (reportsList || []).reduce((acc, report) => {
  //       const year = new Date(report.date).getFullYear()
  //       acc[year] = acc[year] || []
  //       acc[year].push(report)
  //       return acc
  //     }, {})
  //   }, [reportsList])

  //   const sortedYears = useMemo(
  //     () => Object.keys(reportsByYear).sort((a, b) => b - a),
  //     [reportsByYear]
  //   )

  const handleCardClick = id => {
    getReportFN(id);
    setselectedReportID(id);
    setIsReportOpen(true)
    //history.push(`/reports/${id}/edit`)
  }

  const handleControlCardClick = id => {
    getReportFN(id);
    setselectedControlReportID(id);
    setIsControlReportOpen(true);
    //history.push(`/reports/${id}/edit`)
  }

  const handleCardClose = (json) => {
    console.log("save json", json)
    saveReportFN(currentReport.report_id, json)
    setselectedReportID(null)
    setIsReportOpen(false)
    clearCurrentReportFN()
  }

  const handleControlCardClose = (json) => {
    console.log("save json", json)
    saveReportFN(currentReport.report_id, json)
    setselectedControlReportID(null)
    setIsControlReportOpen(false)
    clearCurrentReportFN()
  }

  const toggleDropdown = (id) => {
    //console.log('Toggling dropdown for id:', id);
    setIsDropdownOpen(isDropdownOpen === id ? null : id);
  };


  const handleDelete = (ID) => {
    console.log("DELETED", ID)
    deleteReportFN(ID)
  }


  const handleCreateReport = async () => {
    setIsReportOpen(true)
  }
  const handleCreateControlReport = async () => {
    console.log("Creating contorl", selectedControlReportID)
    setIsControlReportOpen(true)
  }

  return (
    <div className="h-[100dvh] w-full overflow-y-auto figma-theme figma-surface bg-[#F8F8F8]">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-10 py-6">


        {/* Page heading */}
        <div className="mb-3">
          <h1 className="text-xl md:text-2xl font-medium tracking-wide text-[var(--foreground)]">
            Risk &amp; Control Reports
          </h1>
          <p className="text-xs md:text-sm text-[var(--muted-foreground)]">
            Manage and review your organization's risk assessments and control reports
          </p>
        </div>

        {/* Segmented Tabs ABOVE the toolbar (pill style) */}
        <div className="w-full flex items-center justify-start mb-3">
          <div
            role="tablist"
            aria-label="Report type"
            className="inline-flex items-center gap-1 bg-[#ECEFF3] rounded-full p-1 shadow-inner"
          >
            {/* Risk tab */}
            <button
              role="tab"
              aria-selected={page === "risk"}
              onClick={() => setPage("risk")}
              className={`group inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition
        ${page === "risk"
                  ? "bg-white text-[var(--foreground)] shadow"
                  : "text-[var(--muted-foreground)] hover:text-[var(--foreground)]"}`}
            >
              {/* shield icon */}
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M12 3l7 3v6a8 8 0 01-7 7 8 8 0 01-7-7V6l7-3z" />
              </svg>
              <span className="whitespace-nowrap">Risk Reports</span>
              <span className={`text-xs rounded-full px-2 py-0.5 border
        ${page === "risk"
                  ? "border-[color:var(--border)] text-[var(--foreground)]"
                  : "border-transparent bg-white/60 text-[var(--foreground)]"}`}>
                {riskCount}
              </span>
            </button>

            {/* Control tab */}
            <button
              role="tab"
              aria-selected={page === "control"}
              onClick={() => setPage("control")}
              className={`group inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition
        ${page === "control"
                  ? "bg-white text-[var(--foreground)] shadow"
                  : "text-[var(--muted-foreground)] hover:text-[var(--foreground)]"}`}
            >
              {/* checklist icon */}
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M9 7h10M9 12h10M9 17h10M5 7h.01M5 12h.01M5 17h.01" strokeLinecap="round" />
                <path d="M4 7l1.2 1.2L7 6.4" strokeLinecap="round" />
              </svg>
              <span className="whitespace-nowrap">Control Reports</span>
              <span className={`text-xs rounded-full px-2 py-0.5 border
        ${page === "control"
                  ? "border-[color:var(--border)] text-[var(--foreground)]"
                  : "border-transparent bg:white/60 text-[var(--foreground)]"}`}>
                {controlCount}
              </span>
            </button>
          </div>
        </div>
        {/* Toolbar: search + view toggle + add button */}
        <div className="w-full bg-[var(--card)] text-[var(--foreground)] border border-[color:var(--border)] rounded-[var(--radius)] px-4 py-3 flex items-center justify-between gap-4 shadow-sm">

          {/* Search */}
          <div className="relative flex-1 max-w-[60%]">
            <svg
              className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--muted-foreground)]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none" viewBox="0 0 24 24" stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M21 21l-4.35-4.35m1.85-5.15a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search reports…"
              className="w-full pl-8 pr-3 py-1.5 rounded-md bg-[var(--input-background)] text-[var(--foreground)] border border-[color:var(--border)] focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)] text-sm"
            />
          </div>

          {/* View toggle (medium size, sleek black style) */}
          <div className="flex items-center rounded-md border border-[color:var(--border)] overflow-hidden shrink-0">
            <button
              type="button"
              onClick={() => setViewMode('grid')}
              title="Grid view"
              className={`flex items-center gap-1.5 px-3 py-2 text-sm transition-colors duration-150
      ${viewMode === 'grid'
                  ? 'bg-black text-white font-medium'
                  : 'bg-[var(--card)] text-[var(--muted-foreground)] hover:bg-black/80 hover:text-white'}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z" />
              </svg>
              Grid
            </button>

            <button
              type="button"
              onClick={() => setViewMode('table')}
              title="List view"
              className={`flex items-center gap-1.5 px-3 py-2 text-sm border-l border-[color:var(--border)] transition-colors duration-150
      ${viewMode === 'table'
                  ? 'bg-black text-white font-medium'
                  : 'bg-[var(--card)] text-[var(--muted-foreground)] hover:bg-black/80 hover:text-white'}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h18M3 12h18M3 18h18" />
              </svg>
              List
            </button>
          </div>


          {/* Add Report button */}
          <button
            onClick={() => {
              if (page === "risk") handleCreateReport();
              else handleCreateControlReport();
            }}
            className="flex items-center justify-center gap-1.5 h-8 px-3 rounded-md bg-black text-white text-sm border border-black hover:bg-black/80 transition shrink-0"
          >
            <LuPlus className="w-4 h-4" />
            <span className="hidden sm:inline">{page === "risk" ? "Risk Report" : "Control Report"}</span>
          </button>

        </div>


        {/* Content */}
        <div className="w-full mt-4 pb-24">
          {/* RISK LIST */}
          {page === "risk" && (
            <>
              {viewMode === "grid" ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                  {filteredReportsList?.map((report) => {
                    const risks =
                      report.total_risks ?? report.totalRisks ?? report.riskCount ?? report.risksCount ?? 0;
                    const findings = report.findings ?? 0;
                    const category =
                      report.category ?? report.type ?? report.report_type ?? null;

                    return (
                      <div
                        key={report.id}
                        className="relative w-full cursor-pointer rounded-xl border border-[color:var(--border)] bg-[var(--card)] p-4 text-[var(--foreground)] shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleCardClick(report.id); setIsDropdownOpen(null); }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick(report.id); } }}
                      >
                        {/* 3 dots - pinned corner & click-safe */}
                        <div
                          className="absolute top-1 right-1"
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown(report.id); }}
                            className="rounded-full p-1.5 hover:bg-[var(--accent)]"
                          >
                            <BsThreeDots className="h-4 w-4 text-[var(--muted-foreground)]" />
                          </button>

                          {isDropdownOpen === report.id && (
                            <div
                              className="absolute right-0 top-8 z-50 w-36 rounded-md border border-[color:var(--border)] bg-[var(--card)] shadow-md"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleCardClick(report.id); setIsDropdownOpen(null); }}
                                className="block w-full px-3 py-1.5 text-left text-xs hover:bg-[var(--accent)]"
                              >
                                Edit
                              </button>
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(report.id); setIsDropdownOpen(null); }}
                                className="block w-full px-3 py-1.5 text-left text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Title */}
                        <h2 className="mb-1 pr-8 text-base font-medium line-clamp-1">{report.title}</h2>

                        {/* Subtitle */}
                        {report.subtitle && (
                          <p className="text-[13px] text-[var(--muted-foreground)]">
                            {report.subtitle}
                          </p>
                        )}

                        {/* Date */}
                        <div className="mt-3 flex items-center gap-2 text-sm text-[var(--muted-foreground)]">
                          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v3M8 2v3M4 7h16M5 22h14a2 2 0 0 0 2-2V7H3v13a2 2 0 0 0 2 2z" />
                          </svg>
                          <span>{new Date(report.updated_at).toLocaleDateString()}</span>
                        </div>



                        {/* Owner */}
                        <div className="mt-2 flex items-center gap-2 text-sm text-[var(--muted-foreground)]">
                          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                          </svg>
                          <span>Owner: Mustafa Güneş</span>
                        </div>

                        {/* Findings (red when > 0) */}
                        <div className="mt-1.5 text-sm">
                          <span className="text-[var(--muted-foreground)]">Findings: </span>
                          <span className={findings > 0 ? "text-red-500 font-medium" : "text-[var(--muted-foreground)]"}>
                            {findings}
                          </span>
                        </div>

                        {/* Bottom: full-width Download + risks chip at left (optional) */}
                        <div className="mt-4">
                          {/* Optional small risks chip above the button, aligned left (kept subtle) */}
                          <div className="mb-2">
                            <span className="inline-flex items-center rounded-full border border-[color:var(--border)] px-2 py-0.5 text-xs text-[var(--foreground)]">
                              Risks: {risks}
                            </span>
                          </div>

                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); /* hook up download */ }}
                            className="flex w-full items-center justify-center gap-2 rounded-md border border-[color:var(--border)] px-3 py-2 text-sm hover:bg-[var(--accent)]"
                          >
                            <LuDownload className="h-4 w-4" />
                            Download
                          </button>
                        </div>
                      </div>
                    );
                  })}

                </div>
              ) : (
                /* stacked list view */
                <div className="space-y-3">
                  {filteredReportsList?.map((report) => {
                    const risks = report.risksCount ?? 0;
                    const findings = report.findings ?? 0;

                    return (
                      <div
                        key={report.id}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleCardClick(report.id); }}
                        className="relative flex items-center justify-between gap-6 rounded-xl border border-[color:var(--border)] bg-[var(--card)] p-4 hover:shadow-md transition cursor-pointer"
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick(report.id); } }}
                      >
                        {/* LEFT SIDE */}
                        <div className="min-w-0 flex-1">
                          <div className="text-[15px] font-medium text-[var(--foreground)] line-clamp-1">{report.title}</div>

                          {report.subtitle && (
                            <div className="mt-1 text-sm text-[var(--muted-foreground)] line-clamp-2">
                              {report.subtitle}
                            </div>
                          )}

                          <div className="mt-3">
                            <span className="inline-flex items-center rounded-full border border-[color:var(--border)] px-2 py-0.5 text-xs text-[var(--foreground)]">
                              Risks: {risks}
                            </span>
                          </div>
                        </div>

                        {/* RIGHT SIDE — vertically centered content */}
                        <div className="flex items-center gap-4" onClick={(e) => e.stopPropagation()}>
                          {/* Meta info stacked */}
                          <div className="flex flex-col gap-1 text-[13px] text-[var(--muted-foreground)] items-end">
                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v3M8 2v3M4 7h16M5 22h14a2 2 0 0 0 2-2V7H3v13a2 2 0 0 0 2 2z" />
                              </svg>
                              {new Date(report.updated_at).toLocaleDateString()}
                            </span>

                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                              </svg>
                              Mustafa Güneş
                            </span>

                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                              </svg>
                              <span>
                                Findings: <span className="text-red-500 font-medium">{findings}</span>
                              </span>
                            </span>
                          </div>

                          {/* Download */}
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); /* hook download */ }}
                            className="inline-flex items-center gap-1.5 px-3 py-2 text-sm rounded-md border border-[color:var(--border)] hover:bg-[var(--accent)]"
                          >
                            <LuDownload className="w-4 h-4" />
                            Download
                          </button>
                        </div>

                        {/* Top-right menu — tighter to corner & click-safe */}
                        <div
                          className="absolute top-1 right-1"
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                        >
                          <button
                            aria-haspopup="menu"
                            aria-expanded={isDropdownOpen === report.id}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown(report.id); }}
                            className="p-1.5 hover:bg-[var(--accent)] rounded-full"
                          >
                            <BsThreeDots className="w-4 h-4 text-[var(--muted-foreground)]" />
                          </button>

                          {isDropdownOpen === report.id && (
                            <div
                              className="absolute right-0 top-8 w-36 bg-[var(--card)] border border-[color:var(--border)] rounded-md shadow-md z-[60]"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleCardClick(report.id); setIsDropdownOpen(null); }}
                                className="block w-full text-left px-3 py-1.5 text-xs hover:bg-[var(--accent)]"
                              >
                                Edit
                              </button>
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(report.id); setIsDropdownOpen(null); }}
                                className="block w-full text-left px-3 py-1.5 text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>


                      </div>
                    );
                  })}

                </div>
              )}
            </>
          )}

          {/* CONTROL LIST (mirrors risk) */}
          {page === "control" && (
            <>
              {viewMode === "grid" ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                  {filteredControlReportsList?.map((report) => {
                    const findings = report.findings ?? 0;

                    return (
                      <div
                        key={report.id}
                        className="relative w-full cursor-pointer rounded-xl border border-[color:var(--border)] bg-[var(--card)] p-4 text-[var(--foreground)] shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleControlCardClick(report.id); setIsDropdownOpen(null); }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleControlCardClick(report.id); } }}
                      >
                        {/* 3 dots - pinned top right */}
                        <div
                          className="absolute top-1 right-1"
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown(report.id); }}
                            className="rounded-full p-1.5 hover:bg-[var(--accent)]"
                          >
                            <BsThreeDots className="h-4 w-4 text-[var(--muted-foreground)]" />
                          </button>

                          {isDropdownOpen === report.id && (
                            <div
                              className="absolute right-0 top-8 z-50 w-36 rounded-md border border-[color:var(--border)] bg-[var(--card)] shadow-md"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleControlCardClick(report.id); setIsDropdownOpen(null); }}
                                className="block w-full px-3 py-1.5 text-left text-xs hover:bg-[var(--accent)]"
                              >
                                Edit
                              </button>
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(report.id); setIsDropdownOpen(null); }}
                                className="block w-full px-3 py-1.5 text-left text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Title */}
                        <h2 className="mb-1 pr-8 text-base font-medium line-clamp-1">
                          {report.title}
                        </h2>

                        {/* Subtitle */}
                        {report.subtitle && (
                          <p className="text-[13px] text-[var(--muted-foreground)]">
                            {report.subtitle}
                          </p>
                        )}

                        {/* Date */}
                        <div className="mt-3 flex items-center gap-2 text-sm text-[var(--muted-foreground)]">
                          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v3M8 2v3M4 7h16M5 22h14a2 2 0 0 0 2-2V7H3v13a2 2 0 0 0 2 2z" />
                          </svg>
                          <span>{new Date(report.updated_at).toLocaleDateString()}</span>
                        </div>

                        {/* Owner */}
                        <div className="mt-2 flex items-center gap-2 text-sm text-[var(--muted-foreground)]">
                          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                          </svg>
                          <span>Owner: Mustafa Güneş</span>
                        </div>

                        {/* Findings */}
                        <div className="mt-1.5 text-sm">
                          <span className="text-[var(--muted-foreground)]">Findings: </span>
                          <span className={findings > 0 ? "text-red-500 font-medium" : "text-[var(--muted-foreground)]"}>
                            {findings}
                          </span>
                        </div>

                        {/* Download button */}
                        <div className="mt-4">
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); /* hook download */ }}
                            className="flex w-full items-center justify-center gap-2 rounded-md border border-[color:var(--border)] px-3 py-2 text-sm hover:bg-[var(--accent)]"
                          >
                            <LuDownload className="h-4 w-4" />
                            Download
                          </button>
                        </div>
                      </div>
                    );
                  })}

                </div>
              ) : (
                /* stacked list view */
                <div className="space-y-3">
                  {filteredControlReportsList?.map((report) => {
                    const findings = report.findings ?? 0;

                    return (
                      <div
                        key={report.id}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleControlCardClick(report.id); }}
                        className="relative flex items-center justify-between gap-6 rounded-lg border border-[color:var(--border)] bg-[var(--card)] p-4 hover:shadow-md transition cursor-pointer"
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleControlCardClick(report.id); } }}
                      >
                        {/* LEFT SIDE */}
                        <div className="min-w-0 flex-1">
                          {/* Title */}
                          <div className="text-sm font-medium text-[var(--foreground)] line-clamp-1">
                            {report.title}
                          </div>

                          {/* Subtitle */}
                          {report.subtitle && (
                            <div className="mt-1 text-sm text-[var(--muted-foreground)] line-clamp-2">
                              {report.subtitle}
                            </div>
                          )}

                          {/* Tag / Extra label */}
                          <div className="mt-3">
                            <span className="inline-flex items-center rounded-full border border-[color:var(--border)] px-2 py-0.5 text-xs text-[var(--foreground)]">
                              Control Report
                            </span>
                          </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="flex items-center gap-4" onClick={(e) => e.stopPropagation()}>
                          {/* Meta info stacked vertically */}
                          <div className="flex flex-col gap-1 text-[13px] text-[var(--muted-foreground)] items-end">
                            {/* Date */}
                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v3M8 2v3M4 7h16M5 22h14a2 2 0 0 0 2-2V7H3v13a2 2 0 0 0 2 2z" />
                              </svg>
                              {new Date(report.updated_at).toLocaleDateString()}
                            </span>

                            {/* Owner */}
                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 20a8 8 0 0116 0" />
                              </svg>
                              Mustafa Güneş
                            </span>

                            {/* Findings */}
                            <span className="inline-flex items-center gap-1.5">
                              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                              </svg>
                              <span>
                                Findings: <span className="text-red-500 font-medium">{findings}</span>
                              </span>
                            </span>
                          </div>

                          {/* Download button */}
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); /* hook download */ }}
                            className="inline-flex items-center gap-1.5 px-3 py-2 text-sm rounded-md border border-[color:var(--border)] hover:bg-[var(--accent)]"
                          >
                            <LuDownload className="w-4 h-4" />
                            Download
                          </button>
                        </div>

                        {/* 3-dots menu — pinned to true top-right */}
                        <div
                          className="absolute top-1 right-1"
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown(report.id); }}
                            className="p-1.5 hover:bg-[var(--accent)] rounded-full"
                          >
                            <BsThreeDots className="w-4 h-4 text-[var(--muted-foreground)]" />
                          </button>

                          {isDropdownOpen === report.id && (
                            <div
                              className="absolute right-0 top-8 w-36 bg-[var(--card)] border border-[color:var(--border)] rounded-md shadow-md z-50"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleControlCardClick(report.id); setIsDropdownOpen(null); }}
                                className="block w-full text-left px-3 py-1.5 text-xs hover:bg-[var(--accent)]"
                              >
                                Edit
                              </button>
                              <button
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(report.id); setIsDropdownOpen(null); }}
                                className="block w-full text-left px-3 py-1.5 text-xs text-[var(--destructive)] hover:bg-[var(--accent)]"
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}


                </div>
              )}
            </>
          )}
        </div>


        {/* Popups (kept as-is from your code) */}
        <Popup open={isReportOpen && selectedReportID !== null && currentReport !== null} onClose={() => setIsReportOpen(false)} contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '1500px', marginTop: '14vh' }}>
          <Report department_id={activeDepartmentId} is_new={false} propData={currentReport} closeReport={(json) => handleCardClose(json)} />
        </Popup>

        <Popup open={isReportOpen && selectedReportID == null} onClose={() => setIsReportOpen(false)} contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '1500px', marginTop: '14vh' }}>
          <Report department_id={activeDepartmentId} is_new={true} closeReport={(json) => handleCardClose(json)} />
        </Popup>

        <Popup open={isControlReportOpen && selectedControlReportID !== null && currentReport !== null} onClose={() => setIsControlReportOpen(false)} contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '1500px', marginTop: '14vh' }}>
          <ControlReport department_id={activeDepartmentId} is_new={false} propData={currentReport} closeReport={(json) => handleControlCardClose(json)} />
        </Popup>

        <Popup open={isControlReportOpen && selectedControlReportID == null} onClose={() => setIsControlReportOpen(false)} contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '1500px', marginTop: '14vh' }}>
          <ControlReport department_id={activeDepartmentId} is_new={true} closeReport={(json) => handleControlCardClose(json)} />
        </Popup>

        {/* Delete modal (kept) */}
        {confirmDeleteId && (
          <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 shadow-lg w-80">
              <h2 className="text-lg font-semibold mb-3 text-[#3b3b3b]">Confirm Delete</h2>
              <p className="mb-5 text-gray-600">Are you sure you want to delete this report?</p>
              <div className="flex justify-between">
                <button
                  onClick={() => setConfirmDeleteId(null)}
                  className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    handleDelete(confirmDeleteId);
                    setConfirmDeleteId(null);
                  }}
                  className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

}

const mapStateToProps = state => {
  console.log("Reports Page details", state, state.reports.reports)

  return {
    token: state.auth.token,
    activeDepartmentId: state.department.activeDepartmentId,

    reportsList: state.reports.reports ? state.reports.reports.filter(report => report.report_type === "1") : [],
    controlReportsList: state.reports.reports ? state.reports.reports.filter(report => report.report_type === "2") : [],

    currentReport: state.reports.currentReport,
  }
}


const mapDispatchToProps = dispatch => ({
  getReportsFN: () => dispatch(getReports()),
  getReportFN: (id) => dispatch(getReport(id)),
  createReportFN: (title, json) => dispatch(createReport(title, json)),
  deleteReportFN: (id) => dispatch(deleteReport(id)),
  clearCurrentReportFN: () => dispatch(clearCurrentReport()),
  saveReportFN: (id, json) => dispatch(saveReport(id, json)),
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(ReportsPage)